module.exports = __webpack_public_path__ + "fonts/text-security-disc.7c83ea2a.ttf";